import { OnSuccessCallback, useCustomMutation } from './index';

import { QueryError, QueryKeys } from '../queries';

import Config from '../../config';
import { METHODS } from '../constants';
import { BookToTaxCode } from '../../administration/clientAdministrationPage/types';
import { ADD_OR_UPDATE_VALUES } from '../../administration/shared/constants';

export type BookToTaxMutationVariable = Omit<BookToTaxCode, 'linkedFlag'>;

export const useAddBookToTaxCode = (onSuccess?: OnSuccessCallback<Response, BookToTaxMutationVariable>) =>
  useCustomMutation<Response, QueryError, BookToTaxMutationVariable>({
    handleData: bookToTaxCode => ({
      url: Config.endpoints.ADD_BOOK_TO_TAX_CODE_DESCRIPTION,
      method: METHODS.POST,
      body: bookToTaxCode,
    }),
    invalidateKey: query => [QueryKeys.bookToTaxCodes.BookToTaxCodes].includes(query.queryKey[0] as string),
    errorMessage: 'Creating book to tax code failed',
    successMessage: 'Book to tax code created successfully',
    onSuccess,
  });

export const useUpdateBookToTaxCode = (onSuccess?: OnSuccessCallback<Response, BookToTaxMutationVariable>) =>
  useCustomMutation<Response, QueryError, BookToTaxMutationVariable>({
    handleData: bookToTaxCode => ({
      url: Config.endpoints.UPDATE_BOOK_TO_TAX_CODE_DESCRIPTION,
      method: METHODS.PUT,
      body: bookToTaxCode,
    }),
    invalidateKey: query => [QueryKeys.bookToTaxCodes.BookToTaxCodes].includes(query.queryKey[0] as string),
    errorMessage: 'Updating book to tax code failed',
    successMessage: 'Book to tax code updated successfully',
    onSuccess,
  });

export const useRemoveBookToTaxCode = (onSuccess?: OnSuccessCallback<Response, BookToTaxMutationVariable>) =>
  useCustomMutation<Response, QueryError, BookToTaxMutationVariable>({
    handleData: ({ periodName, tagCode, countryTaxType }) => ({
      url: Config.endpoints.REMOVE_BOOK_TO_TAX_CODE_DESCRIPTION
        .replace(':periodName', periodName)
        .replace(':tagCode', tagCode)
        .replace(':countryTaxType', countryTaxType),
      method: METHODS.DELETE,
    }),
    invalidateKey: query => [QueryKeys.bookToTaxCodes.BookToTaxCodes].includes(query.queryKey[0] as string),
    errorMessage: 'Removing book to tax code failed',
    successMessage: 'Role removed successfully',
    onSuccess,
  });

export const useValidateBookToTaxCodes = (onSuccess?: OnSuccessCallback<Response, BookToTaxMutationVariable[]>) =>
  useCustomMutation<Response, QueryError, BookToTaxMutationVariable[]>({
    handleData: bookToTaxCodes => ({
      url: Config.endpoints.VALIDATE_BOOK_TO_TAX_CODE_DESCRIPTIONS,
      method: METHODS.POST,
      body: bookToTaxCodes,
    }),
    invalidateKey: [],
    errorMessage: 'Updating book to tax code failed',
    successMessage: 'Book to tax code updated successfully',
    onSuccess,
  });


type ImportBookToTaxCodesVariable = (BookToTaxMutationVariable & { addOrUpdate: string })[]

export const useImportBookToTaxCodes = (onSuccess?: OnSuccessCallback<Response, ImportBookToTaxCodesVariable>) =>
  useCustomMutation<Response, QueryError, ImportBookToTaxCodesVariable>({
    handleData: bookToTaxCodes => ({
      url: Config.endpoints.IMPORT_BOOK_TO_TAX_CODE_DESCRIPTIONS,
      method: METHODS.POST,
      body: bookToTaxCodes.filter(entity => entity.addOrUpdate !== ADD_OR_UPDATE_VALUES.NO_CHANGE),
    }),
    invalidateKey: query => [QueryKeys.bookToTaxCodes.BookToTaxCodes].includes(query.queryKey[0] as string),
    errorMessage: 'Importing book to tax code failed',
    successMessage: 'Book to tax code imported successfully',
    onSuccess,
  });

